export default __webpack_public_path__ + "locales/hy-AM/ChangeEmailDialog.json?hash=fbf8526f172947b62d897c7e5bc138eb";